module.exports = __webpack_public_path__ + "img/ingredienten-dadels-met-bacon-en-amandelen.76e9f058.jpeg";